import { ApiError } from "@common/api";
import { TFunction } from "i18next";

export const translateBoolean = (val: boolean | undefined) => {
  if (val === undefined) return "";
  return val ? "Yes" : "No";
};

export const translateGeoLocation = (val: boolean | undefined) => {
  if (val === undefined) return "";
  return val ? "Automatic" : "Manual";
};

export const getKBSize = (size: number, t: TFunction) => {
  let fileSize = "";
  if (size != 0) {
    var rSize = Math.floor(Math.log(size) / Math.log(1024));

    fileSize =
      (size / Math.pow(1024, rSize)).toFixed(2) +
      " " +
      [t("B"), t("kB"), t("MB"), t("GB"), t("TB")][rSize];
  } else if (Number.isNaN(size)) {
    fileSize = t("Unknown");
  } else {
    fileSize = "0 " + t("B");
  }
  return fileSize;
};

export const getMaxKBSize = (size: number, total: number, t: TFunction) => {
  let fileSize = "";
  if (total != 0) {
    var rSize = Math.floor(Math.log(total) / Math.log(1024));
    fileSize =
      (size / Math.pow(1024, rSize)).toFixed(2) +
      "/" +
      (total / Math.pow(1024, rSize)).toFixed(2) +
      " " +
      [t("B"), t("kB"), t("MB"), t("GB"), t("TB")][rSize];
  }
  return fileSize;
};

export const uploadErrorMapper = (
  error: ApiError,
  t: TFunction,
  contextParameter?: string,
  maxSize?: number
) => {
  switch (error.response.data.error) {
    case "com.avispl.symphony.api.common.error.InvalidArgumentException":
      switch (contextParameter) {
        case "file.size": {
          return maxSize !== undefined
            ? t("File exceeds the maximum upload size {{size}}", {
                size: getKBSize(maxSize, t),
              })
            : t("File exceeds the maximum upload size");
        }
        case "file.extension": {
          return t("File extension is not supported");
        }
        case "account": {
          return t("Insufficient storage available");
        }
      }
    case "com.auth0.jwt.exceptions.TokenExpiredException":
    case "com.auth0.jwt.exceptions.JWTDecodeException":
      return error.response.data.message;

    default:
      return error;
  }
};

export const checkProtocol = (url: string | undefined) => {
  if (url && !url.includes("://")) {
    url = "http://" + url;
  }
  return url;
};
